import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getHasPasskeysEnabled } from '../selectors';

const PasskeysWrapper = ({
  IdentityUiPasskeysRegistration,
  loadStatus,
  ...rest
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  if (loadStatus.all !== 'complete') {
    return null;
  }

  const ownProps = {
    ...rest, loadStatus,
  };
  return <IdentityUiPasskeysRegistration {...ownProps} />;
};

PasskeysWrapper.propTypes = {
  IdentityUiPasskeysRegistration: PropTypes.func.isRequired,
  hasPasskeysEnabled: PropTypes.bool.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,

};

export const ComponentToTest = PasskeysWrapper;

const loadDataAsProps = ({ store: { dispatch, getState }, ownProps: { router, location } }) => ({
  IdentityUiPasskeysRegistration: () => {
    if (!getHasPasskeysEnabled(getState())) {
      return router.replace(`${location.pathname}/error/404`);
    }

    return dispatch(queryModuleWithData('identity-ui-passkeys-registration'));
  },
});

const hocChain = compose(
  oneAppModuleWrapper(PasskeysWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(PasskeysWrapper);
